import React from "react";
import foto from "../../images/Calendario Cigno 20232024.jpg"
import FrecciaIndietro from "../../commons/FrecciaIndietro";
import Space from "../../commons/Space";
import black from "../../images/News/Black_friday.jpg"
import TitoloSezioni from "../../commons/TitoloSezioni";
import "./NewsPagesFoto.css"
import "../../styles/News.css"
import ScrollToTopOnMount from "../../components/ScrollToTopOnMount";
import sanvalentino from "../../images/News/Promozioni San Valentino.jpg"
import pmarzo from "../../images/News/Promo_marzo.png"
import SpaceL from "../../commons/SpaceL";
import fototuffo1 from "../../images/News/Carnevale/IMG_9657.jpg";
import fototuffo2 from "../../images/News/Carnevale/IMG_9660.jpg";
import fototuffo3 from "../../images/News/Carnevale/IMG_9665.jpg";
import foto1 from "../../images/News/Carnevale/IMG_9642.jpg";
import foto2 from "../../images/News/Carnevale/IMG_9649.jpg";
import foto3 from "../../images/News/Carnevale/IMG_9671.jpg";
import foto4 from "../../images/News/Carnevale/IMG_9646.jpg";
import foto5 from "../../images/News/Carnevale/IMG_9644-2.jpg";
import fotorun from "../../images/News/Carnevale/PHOTO-2024-02-17-12-35-14.jpg";
import {Link} from "react-router-dom";
import insta from "../../icone/icons8-instagram-48.png";
import facebook from "../../icone/icons8-facebook-48.png";
import sirene from "../../images/News/Sirene.jpg";



function PromoMarzoNews () {
    return(
        <div className="text-center">
            <ScrollToTopOnMount />
            <FrecciaIndietro indirizzo={"/news"} />
            <p className="text-center" style={{ fontSize: "22px", fontFamily: "Hammersmith One" }}>{"Marzo 2024"}</p>
            <div className="container-foto-news m-auto" style={{display: "flex", flexDirection: "column"}}>
                <a style={{alignSelf: "end"}} href={pmarzo} download>
                    <i style={{fontSize: "2em", color: "grey", marginRight: "0.5em"}} className="bi bi-download"></i>
                </a>
                <img src={pmarzo} style={{width: "100%"}}></img>
            </div>
            <Space />

        </div>
    )
}
export default PromoMarzoNews